import { fmt } from "@/lib/api";
import { biasCls, alertChip } from "@/lib/terminalUtils";
import { market } from "@/lib/symbols";

export const WatchlistTable = ({ signals, selected, onSelect }) => (
  <div className="border border-white/10 bg-[#0d1219]" data-testid="watchlist-table">
    <p className="border-b border-white/10 px-4 py-3 font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">Watchlist</p>
    <div className="overflow-x-auto">
      <table className="w-full min-w-[560px] text-left font-mono text-xs">
        <thead>
          <tr className="border-b border-white/5 text-[9px] uppercase tracking-widest text-mute-dim">
            <th className="px-4 py-2.5">Symbol</th><th className="px-4 py-2.5">Bias</th>
            <th className="px-4 py-2.5">Setup</th><th className="px-4 py-2.5">Score</th>
            <th className="px-4 py-2.5">Price</th><th className="px-4 py-2.5 text-right">Change</th>
          </tr>
        </thead>
        <tbody>
          {signals.map((s) => {
            const up = (s.change_pct ?? 0) >= 0;
            return (
              <tr key={s.symbol} onClick={() => onSelect(s.symbol)} data-testid={`watchlist-row-${s.symbol.toLowerCase()}`}
                className={`cursor-pointer border-b border-white/5 transition-colors hover:bg-white/[0.04] ${selected === s.symbol ? "bg-white/[0.05]" : ""}`}>
                <td className="px-4 py-2.5 font-bold text-white">{s.symbol}</td>
                <td className={`px-4 py-2.5 font-bold ${biasCls(s.mtf?.["1H"])}`}>{s.mtf?.["1H"] || "…"}</td>
                <td className="px-4 py-2.5">
                  {s.admin_off ? (
                    <span className="border border-white/20 bg-white/5 px-1.5 py-0.5 text-[9px] font-bold text-mute-dim" data-testid={`watchlist-off-${s.symbol.toLowerCase()}`}>OFF</span>
                  ) : s.locked ? (
                    <span className="border border-warn/40 bg-warn/10 px-1.5 py-0.5 text-[9px] font-bold text-warn" data-testid={`watchlist-locked-${s.symbol.toLowerCase()}`}>TERKUNCI</span>
                  ) : (
                    <span className={`border px-1.5 py-0.5 text-[9px] font-bold ${alertChip(s.alert)}`}>
                      {s.direction && s.alert === "VALID SETUP" ? s.direction : s.alert}
                    </span>
                  )}
                </td>
                <td className="px-4 py-2.5 text-white">{s.locked || s.admin_off ? "—" : s.total}</td>
                <td className="px-4 py-2.5 text-mute">{fmt(s.price, market[s.symbol]?.d ?? 2)}</td>
                <td className={`px-4 py-2.5 text-right font-bold ${up ? "text-buy" : "text-sell"}`}>
                  {up ? "+" : ""}{s.change_pct}%
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);
